import { logoutProcessInitiatedEvent } from "@urp/amplitude/src/modules/logout/utils";
import mediator from "../../mediator";
import { UMEvents } from "../../mediator/types";
import { getUMEvent } from "../../mediator/events";

export const logout = (functionName = "") => {
  const loggedOutBy = `${functionName} -> logout()`;

  logoutProcessInitiatedEvent({ loggedOutBy });

  const event = getUMEvent(UMEvents.Logout);

  mediator.dispatch({
    type: event.trigger
  });
};
